import React from 'react';
import robotIcon from '../../assets/icons/automatedIcon.png';
import './AutomatedClientIcon.scss';
var AutomatedClientIcon = function () {
    return (React.createElement("img", { className: 'isAutomatedIcon', src: robotIcon }));
};
export default AutomatedClientIcon;
